import React from "react";
import {
  Page,
  Text,
  View,
  Document,
  StyleSheet,
  Image,
} from "@react-pdf/renderer";

const BORDER_COLOR = "#000";
const BORDER_WIDTH = 1;

const styles = StyleSheet.create({
  page: {
    padding: 20,
    paddingBottom: 50, // 🔥 Reservamos espacio para el footer
    fontSize: 10,
    fontFamily: "Helvetica",
  },

  title: {
    fontSize: 10,
    fontWeight: "bold",
    textAlign: "center",
    marginBottom: 10,
  },
  table: {
    display: "flex",
    flexDirection: "column",
    borderWidth: BORDER_WIDTH,
    borderColor: BORDER_COLOR,
    borderStyle: "solid",
    marginTop: 10,
  },
  tableRow: {
    flexDirection: "row",
  },
  tableCell: {
    borderRightWidth: BORDER_WIDTH,
    borderBottomWidth: BORDER_WIDTH,
    borderColor: BORDER_COLOR,
    borderStyle: "solid",
    padding: 4,
  },
  // Para la última celda de la fila quitamos el borde derecho
  lastCell: {
    borderRightWidth: 0,
  },
  // Para la última fila quitamos el borde inferior en celdas
  lastRow: {
    borderBottomWidth: 0,
  },
  signatureLine: {
    borderBottomWidth: BORDER_WIDTH,
    borderColor: BORDER_COLOR,
    height: 40,
    marginTop: 10,
  },
  tableRowColored: {
    backgroundColor: "#bbb",
    borderWidth: 1,
    borderColor: "#999",
    borderStyle: "solid",
  },

  centeredText: {
    textAlign: "center",
  },
  underlined: {
    fontSize: 10,
    textAlign: "justify",
    marginBottom: 5,
    fontWeight: "normal", // Sin negrita
    borderBottomColor: "#000",
    textDecoration: "underline", // Subraya el texto
    fontWeight: "normal !important", // Asegura que no tenga negrita
  },
  boldText: {
    fontSize: 10,
    fontFamily: "Helvetica-Bold", // más negrita real
  },

 content: {
  flexGrow: 1,
},

footerCodeContainer: {
  position: 'absolute',
  bottom: 30, // Distancia desde el borde inferior
  left: 30,
  right: 30,
  textAlign: 'left',
},

footerCode: {
  fontSize: 10,
  fontFamily: "Helvetica",
  color: "black",
  letterSpacing: 1.5,

},

  paragraph: {
    fontSize: 10,
    lineHeight: 1.5, // Aumenta para más espacio entre líneas
    textAlign: "justify",
  },

  ///Estilos para la cabecera
  headerTable: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "flex-start",
    width: "100%",
    marginTop: 10,
  },
  logoColumn: {
    width: "50%",
    alignItems: "center",
  },

  tituloColumn: {
    width: "30%",
    alignItems: "center",
    marginRight: 5,
  },

  banner: {
    width: "100%",
    height: 40,
  },
  infoColumn: {
    width: "20%",
    borderWidth: 1,
    borderColor: "#000",
    height: 50, // asegúrate de tener un alto fijo para alinear contenido
  },

  codeRow: {
    padding: 5,
    borderBottomWidth: 1,
    borderBottomColor: "#000",
    justifyContent: "center", // centra verticalmente
    alignItems: "center", // centra horizontalmente
    height: 30, // divide en dos mitades, por ejemplo
  },

  codeText: {
    fontSize: 8,
    fontFamily: "Helvetica-Bold",
    textAlign: "center",
  },

  dateVersionRow: {
    flexDirection: "row",
    height: "40px",
  },
  dateCell: {
    width: "45%",
    borderRightWidth: 1,
    borderRightColor: "#000",
    paddingLeft: 8,
    justifyContent: "center",
    justifyContent: "flex-start", // alinear arriba
  },
  versionCell: {
    width: "55%",
    paddingLeft: 8,
    justifyContent: "center",
    justifyContent: "flex-start", // alinear arriba
  },
  text: {
    fontSize: 8,
    fontFamily: "Helvetica-Bold",
    textAlign: "center",
  },
});

// Componente para renderizar celdas con flex y estilos
const TableCell = ({ children, flex, isLastCell }) => (
  <View style={[styles.tableCell, { flex }, isLastCell && styles.lastCell]}>
    <Text>{children}</Text>
  </View>
);

const PdfDocumentoDelegacion = ({ data }) => (
  <Document>
    <Page size="A4" style={styles.page}>
      <View style={styles.content}>
      <View fixed>
        <View style={styles.headerTable} fixed>
          <View style={styles.logoColumn}>
            <Image style={styles.banner} src={"Banner_membrete.png"} />
          </View>

          <View style={styles.tituloColumn}>
            <Text style={[styles.title, styles.centeredText, styles.boldText]}>
              FORMATO DE DELEGACIÓN DE FIRMA PARA EL PLAN DE COMPRAS
            </Text>
          </View>

          <View style={styles.infoColumn}>
            <View style={styles.codeRow}>
              <Text style={styles.codeText}>
                <Text style={styles.text}>CÓDIGO</Text>
              </Text>
            </View>
            <View style={styles.dateVersionRow}>
              <View style={styles.dateCell}>
                <Text style={[styles.text]}>
                  <Text style={styles.text}>FECHA</Text>
                </Text>
              </View>
              <View style={styles.versionCell}>
                <Text style={styles.text}>
                  <Text style={styles.text}>VERSIÓN</Text>
                </Text>
              </View>
            </View>
          </View>
        </View>
      </View>

      <View style={styles.table}>
        <View style={styles.tableRow}>
          <TableCell style={styles.boldText} flex={3}>
            <Text style={styles.boldText}>Nombre del proyecto productivo</Text>
          </TableCell>
          <TableCell flex={6} isLastCell>
            {data?.nombre_proyecto || ""}
          </TableCell>
        </View>

        {/* Fila 2: 2 columnas */}
        <View style={styles.tableRow}>
          <TableCell style={styles.boldText} flex={3}>
            <Text style={styles.boldText}>
              Nombre persona en proceso de reincorporación
            </Text>
          </TableCell>
          <TableCell flex={6} isLastCell>
            {data?.nombre_titular || ""}
          </TableCell>
        </View>

        {/* Fila 3: 7 columnas simuladas con flex, aquí se puede ajustar flex para simular colspan */}
        <View style={styles.tableRow}>
          <TableCell flex={2}>
            <Text style={styles.boldText}>Departamento</Text>
          </TableCell>
          <TableCell flex={2}>{data?.departamento || ""}</TableCell>

          <TableCell flex={2}>
            <Text style={styles.boldText}>Número de Cédula</Text>
          </TableCell>
          <TableCell isLastCell flex={2}>
            {data?.numero_cedula || ""}{" "}
          </TableCell>
        </View>

        {/* Fila 4: otra fila con más columnas */}
        <View style={styles.tableRow}>
          <TableCell flex={2}>
            <Text style={styles.boldText}>Municipio</Text>
          </TableCell>
          <TableCell flex={2}>{data?.municipio || ""}</TableCell>

          <TableCell flex={2}>
            <Text style={styles.boldText}>Lugar de expedición</Text>
          </TableCell>
          <TableCell isLastCell flex={2}>
            {data?.lugar_expedicion || ""}{" "}
          </TableCell>
        </View>

        {/* Fila 4: otra fila con más columnas */}
        <View style={styles.tableRow}>
          <TableCell flex={2}>
            <Text style={styles.boldText}>Grupo territorial</Text>
          </TableCell>
          <TableCell flex={2}>{data?.grupo_territorial || ""}</TableCell>

          <TableCell flex={2}>
            <Text style={styles.boldText}>Fecha</Text>
          </TableCell>
          <TableCell flex={2} isLastCell>
            {data?.fecha || ""}
          </TableCell>
        </View>

        {/* Fila 1: 1 columnas */}
        <View style={[styles.tableRow, styles.tableRowColored]}>
          <TableCell flex={1} isLastCell>
            <Text style={[styles.title, styles.centeredText]}>
              ASUNTO: AUTORIZACIÓN PARA FIRMAR EL DOCUMENTO DE ACEPTACIÓN DEL
              PLAN DE COMPRAS PARA EL FORTALECIMIENTO DEL PROYECTO PRODUCTIVO
            </Text>
          </TableCell>
        </View>
        {/* Fila 1: 1 columnas */}
        <View style={styles.tableRow}>
          <TableCell flex={1} isLastCell>
            <Text style={styles.paragraph}>
              {`Yo ${
                data?.nombre_autoriza || "_____________________"
              }, identificado(a) con el número de cédula ${
                data?.cedula_autoriza || "___________"
              } expedida en ${
                data?.lugar_cedula_autoriza || "____________________"
              }, en pleno uso de mis facultades legales e intelectuales, autorizo al/la señor(a) ${
                data?.nombre_autorizado || "____________________"
              }, identificado(a) con el número de cédula ${
                data?.cedula_autorizado || "___________"
              } expedida en ${
                data?.lugar_cedula_autorizado || "____________________"
              } para que en mi nombre y representación firme el documento de aceptación del Plan de Compras para el proyecto productivo de carácter individual o asociativo con código ${
                data?.codigo_pre || "__________"
              } y código SIR ${data?.codigo_sir || "__________"}.`}
            </Text>
          </TableCell>
        </View>

        {/* Fila 1: 1 columnas */}
        <View style={[styles.tableRow, styles.tableRowColored]}>
          <TableCell flex={1} isLastCell>
            <Text style={[styles.title, styles.centeredText]}>
              AUTORIZADO POR:
            </Text>
          </TableCell>
        </View>

        <View style={styles.tableRow}>
          <TableCell flex={3}>
            <Text style={styles.boldText}>Nombre completo:</Text>
          </TableCell>
          <TableCell flex={6} isLastCell>
            {data?.nombre_autoriza_por || ""}
          </TableCell>
        </View>

        <View style={[styles.tableRow, { height: 60 }]}>
          <TableCell flex={3}>
            <Text style={styles.boldText}>Firma:</Text>
          </TableCell>
          <TableCell s flex={6} isLastCell></TableCell>
        </View>

        <View style={styles.tableRow}>
          <TableCell flex={3}>
            <Text style={styles.boldText}>Cédula:</Text>
          </TableCell>
          <TableCell flex={6} isLastCell>
            {data?.cedula_autoriza_por || ""}
          </TableCell>
        </View>

        {/* Fila 1: 1 columnas */}
        <View style={[styles.tableRow, styles.tableRowColored]}>
          <TableCell flex={1} isLastCell>
            <Text style={[styles.title, styles.centeredText]}>
              ACEPTACIÓN DE LA DELEGACIÓN (Anexar copia de la cédula)
            </Text>
          </TableCell>
        </View>

        <View style={styles.tableRow}>
          <TableCell flex={3}>
            <Text style={styles.boldText}>Nombre completo:</Text>
          </TableCell>
          <TableCell flex={6} isLastCell>
            {data?.nombre_aceptacion_delegacion || ""}
          </TableCell>
        </View>

        <View style={[styles.tableRow, { height: 60 }]}>
          <TableCell flex={3}>
            <Text style={styles.boldText}>Firma:</Text>
          </TableCell>
          <TableCell flex={6} isLastCell></TableCell>
        </View>

        <View style={styles.tableRow}>
          <TableCell flex={3}>
            <Text style={styles.boldText}>Cédula:</Text>
          </TableCell>
          <TableCell flex={6} isLastCell>
            {data?.cedula_aceptacion_delegacion || ""}
          </TableCell>
        </View>
        {/* Puedes agregar más filas aquí igual */}
      </View>
      </View>
      
      <View style={styles.footerCodeContainer}>
        <Text style={styles.footerCode}>
          Código Único: {data?.codigo_interno || ""}
        </Text>{" "}
      </View>
    </Page>
  </Document>
);

export default PdfDocumentoDelegacion;
